import React, { useState } from "react";
import { Link } from "react-router-dom";
import PageLayout from "../../components/PageLayout";
import FAQ from "../../components/FAQ";
import SEO from "../../components/SEO";
import { ContactModal } from "../../components/calltoactions/ContactModal";
import { contact } from "../../config/site";

const faqItems = [
  {
    q: "האם אפשר לערער על שלילת רישיון?",
    a: "כן. ניתן להגיש ערעור על שלילת רישיון בפני בית המשפט לתעבורה. עורך דין תעבורה מנוסה יבחן את נסיבות המקרה ויבנה טיעון משפטי לצמצום תקופת השלילה או ביטולה.",
  },
  {
    q: "נהגתי בשכרות — מה קורה עכשיו?",
    a: "עבירת נהיגה בשכרות היא עבירה פלילית הנושאת עונשים כבדים, לרבות שלילת רישיון, קנסות ואף מאסר. חשוב לפנות לעורך דין תעבורה מיד לאחר קבלת הדו״ח או הזימון לחקירה, לפני מתן כל הצהרה.",
  },
  {
    q: "קיבלתי דו״ח מצלמת מהירות — מה אפשר לעשות?",
    a: "ניתן לערער על דו״ח מהירות בבית משפט לתעבורה. במקרים מסוימים ניתן לפגוע בתוקפו הראייתי של הדו״ח, להפחית את הקנס, או למנוע ניכוי נקודות — בהתאם לנסיבות.",
  },
  {
    q: "כמה עולה עורך דין תעבורה?",
    a: "שכר הטרחה תלוי בסוג העבירה ומורכבות התיק. אנו מציעים שקיפות מלאה בנושא עלויות כבר בפגישה הראשונה, ללא הפתעות.",
  },
  {
    q: "האם חובה להגיע לדיון בבית משפט?",
    a: "במקרים רבים ניתן לייצג את הנאשם ללא נוכחות בבית המשפט, בעיקר בעבירות קלות. עורך הדין יודיע לכם מראש מתי נדרשת נוכחות אישית.",
  },
];

const TrafficLawyerBeerSheva = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
  <>
  <PageLayout>
    <SEO
      title="עורך דין תעבורה בבאר שבע | משרד וידבסקי ושות׳"
      description="עורך דין תעבורה בבאר שבע — ייצוג בעבירות תנועה, שלילת רישיון, נהיגה בשכרות, תאונות דרכים וקנסות. פנו למשרד וידבסקי ושות׳ לייעוץ ראשוני."
      path="/orech-din-taaruva"
      faqItems={faqItems}
      breadcrumbs={[
        { name: "דף הבית", url: "/" },
        { name: "עורך דין תעבורה בבאר שבע", url: "/orech-din-taaruva" },
      ]}
    />

    {/* Hero */}
    <section className="content_page_hero">
      <div className="container">
        <ul className="breadcrumb">
          <li><Link to="/">דף הבית</Link></li>
          <li>עורך דין תעבורה בבאר שבע</li>
        </ul>
        <h1>עורך דין תעבורה בבאר שבע</h1>
        <p className="hero_subtitle">
          קיבלתם דו״ח? מולכם הליך פלילי בגין נהיגה בשכרות? רישיונכם בסכנה?
          משרד וידבסקי ושות׳ מתמחה בדיני תעבורה ויגן על זכויותיכם.
        </p>
      </div>
    </section>

    {/* Why you need a lawyer */}
    <section className="page_section">
      <div className="container page_content">
        <div className="page_intro_grid">
          <div>
            <div className="shane_tm_title">
              <span>למה זה חשוב</span>
              <h2>מדוע חשוב להיעזר בעורך דין תעבורה?</h2>
            </div>
            <p>
              עבירות תעבורה עלולות לגרום לתוצאות חמורות: שלילת רישיון, קנסות כבדים,
              ניכוי נקודות שיגרום לאובדן הרישיון, עלייה בפרמיית הביטוח — ובמקרים
              חמורים אף עונש מאסר.
            </p>
            <p>
              עורך דין תעבורה מנוסה יבחן כל תיק לעומקו: תקינות הציוד, הליקויים
              הפרוצדורליים, הנסיבות המקלות — ויפעל להפחתת העונש או לזיכוי מוחלט.
              לעיתים קרובות ההפרש בין ייצוג מקצועי לאי-ייצוג הוא שמירת הרישיון.
            </p>
          </div>
          <div>
            <div className="highlight_box">
              <p>
                ⚠️ <strong>חשוב לדעת:</strong> גם אם אשמתכם נראית ברורה — קיימות
                טענות הגנה שרק עורך דין מנוסה יכול לזהות ולמנף. אל תוותרו על
                ייצוג מקצועי.
              </p>
            </div>
            <ul>
              <li>בחינת חוקיות עצירת הרכב וביצוע הבדיקות</li>
              <li>ערעור על ממצאי מד מהירות וציוד לא מכויל</li>
              <li>הפחתת נקודות וקנסות</li>
              <li>מניעת שלילת רישיון או קיצורה</li>
              <li>ייצוג בהליכים פליליים בגין תאונות דרכים</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    {/* Areas of practice */}
    <section className="page_section bg_light">
      <div className="container page_content">
        <div className="shane_tm_title">
          <span>תחומי הטיפול</span>
          <h2>במה אנחנו מטפלים?</h2>
        </div>
        <div className="page_cards">
          {[
            { icon: "📸", title: "קנסות ומצלמות מהירות", desc: "ערעור על דו״חות מהירות, רמזורים ועבירות חנייה. בחינת תוקף הראיות וניהול הגנה יעילה." },
            { icon: "🍺", title: "נהיגה בשכרות ותחת השפעה", desc: "ייצוג בהליכים פליליים, הפחתת עונש, ערעור על בדיקות ושמירה על הרישיון ככל האפשר." },
            { icon: "🚫", title: "שלילת רישיון", desc: "ערעור על שלילה מינהלית ושיפוטית, ייצוג בבית משפט לתעבורה, בקשות להקלה וחריגים." },
            { icon: "💥", title: "תאונות דרכים", desc: "ייצוג נפגעי תאונות בתביעות נזיקין מול חברות הביטוח — לקבלת הפיצוי המלא המגיע לכם." },
            { icon: "⭐", title: "ניכוי נקודות", desc: "בחינת אפשרויות להפחתת נקודות, ייצוג בפני הרשות לביטחון לאומי בתחבורה." },
            { icon: "🏎️", title: "עבירות חמורות", desc: "נהיגה ללא רישיון, ברח מזירת תאונה, ייצוג אחראי ומקצועי גם בעבירות החמורות ביותר." },
          ].map((s) => (
            <div className="card" key={s.title}>
              <div className="card_icon">{s.icon}</div>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Process */}
    <section className="page_section">
      <div className="container page_content">
        <div className="shane_tm_title">
          <span>תהליך הטיפול</span>
          <h2>איך עובד הטיפול בתיק תעבורה?</h2>
        </div>
        <div className="page_steps">
          {[
            { n: "1", title: "פגישת ייעוץ ובחינת הדו״ח", desc: "נסקור יחד את הנסיבות, הראיות והאפשרויות. נגיד לכם בכנות מה ניתן להשיג ומה האסטרטגיה המומלצת." },
            { n: "2", title: "הגשת ערעור או הכנת הגנה", desc: "נגיש ערעור, נבקש דחיית דיונים לפי הצורך, ונבנה הגנה מבוססת על העובדות ועל הדין." },
            { n: "3", title: "ייצוג בבית המשפט", desc: "נייצג אתכם בדיונים, נחקור עדים ונציג את הטיעונים בצורה מיטבית — שאתם תוכלו להמשיך בחייכם." },
          ].map((s) => (
            <div className="step" key={s.n}>
              <div className="step_number">{s.n}</div>
              <div className="step_content">
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* FAQ */}
    <section className="page_section bg_light">
      <div className="container page_content">
        <div className="shane_tm_title">
          <span>שאלות נפוצות</span>
          <h2>שאלות על עורך דין תעבורה</h2>
        </div>
        <FAQ items={faqItems} />
      </div>
    </section>

    {/* CTA */}
    <section className="page_cta_banner">
      <div className="container">
        <h2>קיבלתם דו״ח או נשלל הרישיון שלכם?</h2>
        <p>אל תחכו — פנו אלינו עוד היום לייעוץ ראשוני בנושא דיני תעבורה.</p>
        <div className="cta_buttons">
          <a href={contact.phones[0].href} className="cta_primary">
            התקשרו עכשיו — {contact.phones[0].label}
          </a>
          <button className="cta_secondary" onClick={() => setIsOpen(true)}>
            שלחו הודעה
          </button>
        </div>
      </div>
    </section>
  </PageLayout>
  <ContactModal isOpen={isOpen} setIsOpen={setIsOpen} />
  </>
  );
};

export default TrafficLawyerBeerSheva;
